<template>
    <img 
        :src="imageUrl" 
        :alt="alt" 
        @click="_onClick"
    />
</template>
  
<script>

import { getAvatar } from '@/api/profile.js';

export default {
name: 'UserAvatar',
props: {
    userId: {
        type: [Number,String],
        required: true,
    },
    alt: {
        type: String,
        required: false,
    },
    editMode: {
        type: Boolean,
        required: false,
    },
    onClick: {
        type: Function,
        required: false,
    },
},


data() {
    return{
        imageUrl: null,
        error: null, // Holds any error messages
    }
},

methods: {
    async fetchImage() {

        try {

            // Fetch image data as blob from the API
            const imageBlob = await getAvatar(this.userId);

            // Revoke any previous object URL to avoid memory leaks
            if (this.imageUrl) {
                URL.revokeObjectURL(this.imageUrl);
            }
            
            // Create an object URL from the blob and assign it to imageUrl
            this.imageUrl = URL.createObjectURL( imageBlob);

            //console.log("imageUrl: " + this.imageUrl);

        } catch (error) {
            console.error('Error fetching the image:', error);
            this.error = "Failed to load image. Please try again.";
            this.imageUrl = null;
        }
    },

    onImageChanged(image) {
      // Handle the updated image URL
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl); // Revoke old object URL
      }
      this.imageUrl = image; // Assign the new image URL
    },

    onNewFile(imageFile) {
      // Handle the updated image URL
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl); // Revoke old object URL
      }
      this.imageUrl = URL.createObjectURL(imageFile); // Assign the new image URL
    },

    _onClick() {
        if (this.onClick) {
            this.onClick();
        }
    },
},

created() {
    this.fetchImage();
},

};
</script>